// extracted by mini-css-extract-plugin
export default {"spoilersWrapper":"Spoilers_spoilersWrapper__niMU9","spoilers":"Spoilers_spoilers__gdoGT","hover":"Spoilers_hover__REPQA","spoilersBody":"Spoilers_spoilersBody__rquFU"};